import { Button, IconButton } from "web/components"
import { UserMessageTile } from "web/components/Tiles"
import TileSet from "web/components/TileSet/TileSet"
import { snakecase } from "web/services/inflector"
import useAddTileWizard from "web/components/AddTileWizard/useAddTileWizard"
import { UseOverviewUtils } from "web/utils/hooks/useOverview.utils"

export default function OverviewView({ view, overview }) {
  const overviewFetchParams = UseOverviewUtils.prepareViewableRequestProperties(
    view.type,
    view.id,
    [view.swrKey]
  )

  const addTile = useAddTileWizard({
    overviewFetchParams,
  })

  async function handleAddTile() {
    await addTile()
    overview.refresh()
  }

  const viewableType = view.type === "group" ? "view_groups" : "views"

  const pdfURL = `/${viewableType}/${view.id}/overviews/${overview.id}.pdf`
  const canEdit = true

  return (
    <div className="min-h-0 grow overflow-y-auto">
      <hr className="mx-3 my-2 md:mx-5 md:my-3" />
      <div className="max-w-[1080px] px-3 pb-4 md:px-5">
        <div className="flex w-full flex-grow flex-nowrap items-end justify-end gap-x-2.5">
          <div>
            <a href={pdfURL}>
              <IconButton outline name="document-arrow-down" />
            </a>
          </div>
          <div>
            {canEdit && (
              <Button
                onClick={handleAddTile}
                variant="secondary_default"
                size="small"
              >
                Add Tile
              </Button>
            )}
          </div>
        </div>

        <div className="mt-3">
          {overview.tiles.length === 0 ? (
            <TileBlankSlate />
          ) : (
            <TileSet
              tiles={overview.tiles}
              maxColumns={2}
              onMoveTile={overview.handleMoveTile}
              onResizeTile={overview.handleResizeTile}
              photos={[]}
              canEdit={canEdit}
              overviewType={overview.type}
              subjectType={snakecase(view.subject_type)}
              modifiedFromTemplate={view.is_modified}
              overview={overview}
            />
          )}
        </div>
      </div>
    </div>
  )
}

function TileBlankSlate() {
  return (
    <UserMessageTile
      message={
        'No tiles have been added to this Overview. You can add one by clicking the "Add Tile" button above.'
      }
    />
  )
}
